Controller = App.loadClass 'core::Angular/Controller'

class exports.PreferencesController extends Controller
    constructor: (@scope, @transitions, @data) ->
        @scope.title = 'Preferences'
        @scope.fullpage = true
        @scope.absolute_errors = true

        # Instance data
        @loadScopeData @data.getUserPreferences(), 'preferences'
        .then () =>
            for key, preference of @scope.preferences.preferences
                preference.expanded = false

        # Functions
        @scope.typeof = (argument) =>
            return typeof argument

        @scope.savePreferences = @savePreferences
        @scope.sendTestMessage = @sendTestMessage
        @scope.expandTextarea = @expandTextarea
        @scope.collapseTextarea = @collapseTextarea
        @scope.formatKey = @formatKey
        @scope.validJson = @validJson

        App.sidebar?.close()
        App.angularSidebar?.close()

    savePreferences: () =>
        @data.saveUserPreferences @scope.preferences
        .then (response) =>
            if response.data.status.type is 'error'
                @setAlert response.data.status
            else
                @clearAlert()

    sendTestMessage: (key) =>
        @data.sendTestMessage @scope.preferences.vcs_username, key

    expandTextarea: (pref) =>
        pref.expanded = true

    collapseTextarea: (pref) =>
        pref.expanded = false

    validJson: (json) =>
        try
            obj = JSON.parse(json)
            return true
        catch error
            return false

    formatKey: (key) =>
        key.replace '_', ' '
            .replace /^([a-z\u00E0-\u00FC])|\s+([a-z\u00E0-\u00FC])/g, (char) =>
                char.toUpperCase()

    # Boilerplate code for loading data into scope variables
    loadScopeData: (promise, key) =>
        return promise.then (response) =>
            if response?.data?.status?.type is 'success'
                @scope[key] = response.data.data
